export default __webpack_public_path__ + "static/media/sitting-chart.5b713774.png";